<template>
    <div>
      <h3 class='text-bold' style="margin-bottom: 15px">{{$t('pages.profile.prompt')}}</h3>
      <div class='k6-box' style="margin-bottom: 15px;">
        <div class='k6-profile-image'>
          <img :src='profile.profilePhoto' alt="Profile image" />
        </div>
        <div class='k6-profile-data'>
          <div class='segment'>
            <span>@{{ profile.username }}</span>
            <h3 class="text-bold">{{ profile.firstName }} {{  profile.lastName }}</h3>
            <span>{{  profile.role }}</span>
          </div>
  
          <div class='segment segment-grid'>
              <span>{{$t("pages.profile.email")}}:</span>
              <span class="segment-data">{{ profile.email }}</span>
              <span>{{$t("pages.profile.studentId")}}:</span>
              <span class="segment-data">{{ profile.studentId }}</span>
          </div>
        </div>
        <div class='k6-profile-actions'>
          <button class='btn btn-success k6-btn' style="border-radius: 30px;" @click.prevent="goToEdit()">
            {{$t("pages.profile.edit")}} <i style='margin-left: 10px;' class='fa fa-pencil'></i>
          </button>
        </div>
      </div>
  
      <!--<div class='k6-box tabs' style='margin-top: 15px'>
          <h4 @click.prevent="setTabView('groups')" :class="{ active: activeTab === 'groups' }" class='text-bold'>
            {{$t("pages.profile.groups")}}
          </h4>
          <h4 @click.prevent="setTabView('surveys')" :class="{ active: activeTab === 'surveys' }" class='text-bold'>
            {{$t("pages.profile.surveys")}}
          </h4>
      </div>-->
  
      <div class='k6-profile-cards' v-if="rolesSelected && rolesSelected.length == 0">
          <div 
            v-for="group in groupList.myGroups.filter(g => !g.isPending)" 
            class='k6-profile-card' 
            :class="[group.groupColor !== null ? group.groupColor : defaultGColor]"
            @click.prevent="goToGroup(group)"
          >
              <div class="card-data">
                  <h2 class="card-title">{{ group.groupName | pickTranslation }}</h2>
                  <span>{{ group.groupDescription | pickTranslation }}</span>
                  <span>{{ group.yearName }}</span>
              </div>
              <div style="font-size: 30px;">
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </div>
          </div>
      </div>
  
      <!--<div class='k6-profile-cards' v-if="activeTab === 'surveys'">
          <div v-for="survery in surverys" class='k6-profile-card' style="background-color: #E7A03B;">
              <div class="card-data">
                  <h2 class="card-title">{{ survery.title }}</h2>
                  <span>
                      <span class="glyphicon glyphicon-calendar"></span>
                      <span>{{$t("pages.profile.solved")}} {{ survery.date | formatDate2 }}</span>
                  </span>
                  <div style="display: flex; gap: 5px; align-items: center;">
                    <div class="k6-progress">
                      <div class="k6-progress-bar" :style="{width: `${survery.result}%`}"></div>
                    </div>
                    <span>{{ survery.result }}% {{$t("pages.profile.correct")}}</span>
                  </div>
              </div>
              <div style="font-size: 30px;">
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </div>
          </div>
      </div>-->
    </div>
  </template>
  
  <script>
  import Rest from './../../services/rest'
  import { mapGetters, mapState } from 'vuex'
  import router from './../../router/router'
  export default {
    data () {
      return {
        profile: {id: '', username: '', email: '', firstName: '', lastName: '', studentId: '', language: '', allowUseOfMyResults: '', role: '', profilePhoto: ''},
        activeTab: 'groups',
        userId: this.uid,
        rolesSelected: null
      }
    },
    props: {
      uid: String
    },
    mounted: function () {
      this.prepareComponent()
    },
    computed: {
      ...mapState({
        groupList: state => state.groupList,
        defaultGColor: state => state.defaultGColor
      }),
      ...mapGetters({
        pictureBaseURL: 'pictureBaseURL',
        avatarUrl: 'getLinkToAvatar'
      })
    },
    methods: {
      prepareComponent () {
        this.$store.dispatch('getGroupsNew')
        this.getData()
      },
      getData () {
        if (!this.uid) {
          this.userId = 'me'
        } else {
          this.getRoles()
        }
        return Rest.request('GET', '/users/' + this.userId).then(data => {
          const { id, username, email, firstName, lastName, studentId, language, allowUseOfMyResults } = data
          this.profile = {
            ...this.profile, id, username, email, firstName, lastName, studentId, language, allowUseOfMyResults
          }
  
          if (data.roles.length > 0) {
            this.profile.role = data['roles'][0].displayName
          } else {
            // if no role -> student
            this.profile.role = this.$t('pages.profile.student')
          }
  
          if (data.profilePictureUrl === null) {
            this.profile.profilePhoto = this.avatarUrl
          } else {
            this.profile.profilePhoto = this.pictureBaseURL + data.profilePictureUrl
          }

          this.rolesSelected = data.roles.map(function (a) {
            return a.id
          })
          this.admit = data['allowUseOfMyResults']
          this.lang.id = data['lngId']
        })
      },
      getRoles: function () {
        return Rest.request('GET', '/roles').then((data) => {
          this.roleList = data
        }).catch(function (err) {
          console.log(err)
        })
      },
      setTabView (tabName) {
        this.activeTab = tabName
      },
      goToEdit (userId) {
        if (!this.uid) {
          router.push({ name: 'profileEdit' })
        } else {
          // admin edit
          router.push({ name: 'adminProfileEdit', params: { uid: this.uid } })
        }
      },
      goToGroup (group) {
        if (!this.uid) {
          router.push({ name: 'profileGroupStats', params: { yearId: group.yearId } })
        } else {
          // admin edit
          router.push({ name: 'adminProfileGroupStats', params: { uid: this.uid, yearId: group.yearId } })
        }
      }
    }
  }
  </script>
  
  <style scoped>
  
  * {
    padding: 0;
    margin: 0;
  }
  
  .k6-box {
    padding: 30px;
    display: flex;
    justify-content: space-between;
    border-radius: 6px;
    background-color: #fff;
    gap: 20px;
  }
  
  .k6-box.tabs {
    margin-top: 10px;
    margin-bottom: 10px;
    width: fit-content;
    gap: 0px;
    padding: 0px;
    border-radius: 0px;
  }
  
  .k6-profile-image {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 150px;
  }
  
  .k6-profile-image img {
    width: 109px;
    height: 109px;
    border-radius: 100%;
    mix-blend-mode: normal;
  /*box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);*/
  }
  
  .k6-profile-data {
    flex: 1;
    display: flex;
    justify-content: flex;
    flex-direction: column;
    gap: 30px;
  }
  
  .segment {
    display: flex;
    flex-direction: column;
  }
  
  .segment-grid.segment {
    display: grid;
    grid-template-columns: 150px 1fr;
  }
  
  .k6-box.tabs > h4 {
    cursor: pointer;
    margin: 0;
    padding: 0;
    padding: 15px;
    padding-bottom: 10px;
    border-bottom: 5px solid transparent;
  }
  
  .k6-box.tabs > .active {
    color: #4AA362;
    border-bottom: 5px solid #4AA362;
  }
  
  .k6-profile-cards {
    cursor: pointer;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  
  .k6-profile-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    background-color: #4AA362;
    padding: 15px;
    color: #fff;
  }
  
  .k6-profile-card > .card-data {
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex: 1;
  }
  
  .k6-progress {
    flex: 1;
    max-width: 300px;
    min-width: 100px;
    height: 9px;
    border-radius: 5px;
    background-color: #ffffff55;
  }
  
  .k6-progress-bar {
    height: 9px;
    background-color: #fff;
    border-radius: 5px;
  }
  
  .k6-profile-card .card-title,
  .text-bold {
      font-weight: bold;
  }
  
  .segment-data {
    color: #B1B1B1
  }
  
  .k6-btn {
    border-radius: 8px;
    background-color: #4AA362;
    border: 0;
    padding: 6px 12px !important;
  }
  
  @media only screen and (max-width: 767px) {
    .k6-box:not(.tabs) {
      flex-direction: column;
    }
  
    .k6-profile-cards {
      grid-template-columns: 1fr;
    }
  
    .k6-profile-image {
      width: 100%;
      margin-bottom: 20px;
    }
  
    .segment-grid.segment {
      display: grid;
      grid-template-columns: 1fr;
    }
  
    .segment-data {
      margin-bottom: 10px;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// Profile.vue?36b03077